/**
 * Constants for Blueprint canvas step & arrow placements
 */

export const CARD_X_STEP = 180;
export const CARD_Y_STEP = 150;
export const CANVAS_Y_OFFSET = 100; // Offset from top, to make room for top banner
